// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lang-switcher .dropdown-menu{min-width:50px !important;margin-top:12px !important}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
